import type {QupFrequencyRule} from '@jobseeker/common-core/utils/qupFrequency';
export const LINKEDIN_SYNC_INITIATION_POINT = 'linkedin_sync';

export const LINKEDIN_SYNC_STALE_MONTHS_THRESHOLD = 3;

export const LINKEDIN_SYNC_DISPLAY_POINT = 'linkedin_sync_shown';

export const LINKEDIN_SYNC_FREQUENCY_RULE: QupFrequencyRule = {
  nonInteractMinGap: 259200, // 3 days
  interactMinGap: 86400, // 1 day
  snoozeTimes: 3,
  freezePeriod: 2592000, // 30 days
};

export interface LinkedInSyncUrlFormCtaConfig {
  primary?: string;
  primaryUnchecked?: string;
  secondary?: string;
}

export interface LinkedInSyncCtaConfig {
  primary?: string;
  secondary?: string;
}

export interface LinkedInSyncChatCopyConfig {
  greeting?: string;
  syncPrompt?: string;
  urlExistsNote?: string;

  freshGreeting?: string;
  freshSyncPrompt?: string;

  existingUrlCta?: LinkedInSyncCtaConfig;

  changesReviewCta?: LinkedInSyncCtaConfig;

  suggestedProfileCta?: LinkedInSyncUrlFormCtaConfig;

  consentFollowupCta?: LinkedInSyncCtaConfig;

  notMyProfileCta?: LinkedInSyncUrlFormCtaConfig;
  shareUrlPrompt?: string;
  shareUrlCta?: LinkedInSyncUrlFormCtaConfig;
  noMismatchMessage?: string;
  mismatchIntro?: string;
  matchedViaApiIntro?: string;
  declinedClosing?: string;
  savedClosing?: string[];
  urlNotFoundError?: string;
  retryExhaustedClosing?: string;

  savingSteps?: string[];

  comparingSteps?: string[];

  consentFollowup?: string[];

  changesAppliedMessage?: string;
  changesReviewFootnote?: string;
  editChangesIntro?: string;
  allSetClosing?: string[];
  noUpdatesClosing?: string[];
  notMyProfilePrompt?: string;
}

const LINKEDIN_SYNC_TEST_EMAILS: string[] =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? []
    : (process.env.NEXT_PUBLIC_LINKEDIN_SYNC_TEST_EMAILS ?? '')
        .split(',')
        .map(email => email.trim().toLowerCase())
        .filter(Boolean);

export const isLinkedInSyncTestUser = (email?: string | null): boolean =>
  !!email && LINKEDIN_SYNC_TEST_EMAILS.includes(email.trim().toLowerCase());
